import React from "react"
import { CustomAttributeValueInputProps } from "../types"

const CustomAttributeValueInput = (props: CustomAttributeValueInputProps) => {
    return (
        <>
            <input
                value={props.value ?? ""}
                onChange={event => {
                    props.onChange(event)
                }}
                type="text"
                className="form-control"
            />
        </>
    )
}

export default CustomAttributeValueInput


// WEBPACK FOOTER //
// ./src/common/form/CustomAttributeValueInput.tsx